import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../ui/Button';
import Input from '../ui/Input';
import styles from './AdminJobPostForm.module.css';

const AdminJobPostForm = ({ onSubmit, onCancel, submitting = false }) => {
  const { userProfile } = useAuth();
  const [formData, setFormData] = useState({
    title: '',
    company: '',
    location: '',
    description: '',
    salary: '',
    url: '',
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.title.trim())       newErrors.title       = 'Title required';
    if (!formData.company.trim())     newErrors.company     = 'Company required';
    if (!formData.location.trim())    newErrors.location    = 'Location required';
    if (!formData.description.trim()) newErrors.description = 'Description required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSubmit({
      ...formData,
      posterUid:  userProfile?.uid,
      posterName: userProfile?.displayName,
      manual:     true,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.formGroup}>
        <Input
          label="Job Title *"
          name="title"
          value={formData.title}
          onChange={handleChange}
          error={errors.title}
          placeholder="e.g. Senior React Developer"
        />
      </div>

      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <Input
            label="Company *"
            name="company"
            value={formData.company}
            onChange={handleChange}
            error={errors.company}
            placeholder="Company Name"
          />
        </div>
        <div className={styles.formGroup}>
          <Input
            label="Location *"
            name="location"
            value={formData.location}
            onChange={handleChange}
            error={errors.location}
            placeholder="Johannesburg, Gauteng"
          />
        </div>
      </div>

      <div className={styles.formGroup}>
        <Input
          label="Salary (optional)"
          name="salary"
          value={formData.salary}
          onChange={handleChange}
          placeholder="R50,000 – R70,000 / month"
        />
      </div>

      <div className={styles.formGroup}>
        <Input
          label="Apply URL (optional)"
          name="url"
          type="url"
          value={formData.url}
          onChange={handleChange}
          placeholder="https://apply.example.com"
        />
      </div>

      <div className={styles.formGroup}>
        <label className={styles.label}>Description *</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows={6}
          className={`${styles.textarea} ${errors.description ? styles.textareaError : ''}`}
          placeholder="Full job description…"
        />
        {errors.description && <span className={styles.errorMsg}>{errors.description}</span>}
      </div>

      <div className={styles.formActions}>
        <Button type="submit" disabled={submitting} variant="primary">
          {submitting ? 'Posting…' : 'Post Job'}
        </Button>
        {onCancel && (
          <Button type="button" onClick={onCancel} variant="ghost">
            Cancel
          </Button>
        )}
      </div>
    </form>
  );
};

export default AdminJobPostForm;
